import React, { useState, useEffect } from "react";
import AddLeaveTypeModal from "./AddLeaveTypeModal";
import api from "../../api/axios";
import { Plus, SquarePen, Trash2 } from "lucide-react";
import Swal from "sweetalert2";

const LeaveTypeManagement = () => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [editLeaveType, setEditLeaveType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchLeaveTypes = async () => {
    try {
      const res = await api.get("/hrms/leave-types");
      console.log(res.data.data);
      setLeaveTypes(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch leaveTypes:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveTypes();
  }, []);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This leaveType will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/hrms/leave-types/${id}`);
          Swal.fire("Deleted!", "LeaveType has been deleted.", "success");
          fetchLeaveTypes();
        } catch (err) {
          Swal.fire(
            "Error",
            err.response?.data?.message || "Delete failed",
            "error"
          );
        }
      }
    });
  };

  const handleEdit = (leaveType) => {
    setEditLeaveType(leaveType);
    setShowModal(true);
  };

  const handleNewLeaveType = () => {
    setEditLeaveType(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditLeaveType(null);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h5 className="fs-4 fw-semibold m-0">Manage LeaveTypes</h5>
          <span className="text-muted fs-6">
            Define work leaveTypes for your property.
          </span>
        </div>
        <button
          type="button"
          className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
          onClick={handleNewLeaveType}
        >
          <Plus size={18} /> Add LeaveType
        </button>
      </div>

      <div className="table-responsive settings-table mt-3">
        <table className="table table-hover m-0">
          <thead>
            <tr className="align-middle border-top">
              <th>Leave Type Name</th>
              <th>Short Code</th>
              <th>Yearly Limit</th>
              <th>Carry Forward Limit</th>
              <th>Consider As</th>
              <th>Description</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center text-muted py-3">
                  Loading...
                </td>
              </tr>
            ) : leaveTypes.length > 0 ? (
              leaveTypes.map((leaveType) => (
                <tr key={leaveType.id}>
                  <td>{leaveType.name}</td>
                  <td>{leaveType.short_name}</td>
                  <td>{leaveType.yearly_limit}</td>
                  <td>{leaveType.carry_forward_limit}</td>
                  <td>{leaveType.consider_as}</td>
                  <td>{leaveType.description}</td>
                  <td>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <SquarePen
                        size={20}
                        role="button"
                        onClick={() => handleEdit(leaveType)}
                      />
                      <Trash2
                        size={20}
                        role="button"
                        className="text-danger"
                        onClick={() => handleDelete(leaveType.id)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted py-3">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <AddLeaveTypeModal
        showModal={showModal}
        onClose={handleCloseModal}
        onLeaveTypeAdded={fetchLeaveTypes}
        editLeaveType={editLeaveType}
      />
    </div>
  );
};

export default LeaveTypeManagement;
